import axios from 'axios';
import {
  CHANGE_USER_EMAIL_URL,
  CHANGE_USER_EMAIL_LOGS_URL,
} from 'api/changeUserEmail/constant';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function changeUserEmail(payload) {
  try {
    return await axios.post(CHANGE_USER_EMAIL_URL, payload);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function getChangeUserEmailLogs(page, size) {
  try {
    return await axios.get(CHANGE_USER_EMAIL_LOGS_URL, {
      params: { page, size },
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
